import React, {
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";

export function idStr(id) {
  return id != null ? String(id) : "";
}

/**
 * Modal Bootstrap (data-api no botão do pai) para treinamentosPermitidos da empresa.
 * `modalId` deve ser único por página (ex.: novo vs edição).
 */
export const TreinamentosPermitidosModalPanel = React.memo(
  forwardRef(function TreinamentosPermitidosModalPanel(
    { catalogoProdutos, onAplicarSelecao, modalId },
    ref
  ) {
    const [draft, setDraft] = useState([]);

    useImperativeHandle(
      ref,
      () => ({
        prepararAbertura: (ids) => {
          setDraft((ids || []).map((x) => idStr(x)));
        },
      }),
      []
    );

    function toggleDraft(id) {
      const sid = idStr(id);
      setDraft((prev) =>
        prev.some((x) => idStr(x) === sid)
          ? prev.filter((x) => idStr(x) !== sid)
          : [...prev, sid]
      );
    }

    const confirmar = useCallback(() => {
      onAplicarSelecao(draft);
    }, [draft, onAplicarSelecao]);

    function selecionarTodasOpcoes() {
      setDraft(catalogoProdutos.map((p) => idStr(p._id)));
    }

    return (
      <div className="modal fade" id={modalId}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title">Selecionar treinamentos</h4>
            </div>
            <div
              className="modal-body"
              style={{ maxHeight: "60vh", overflowY: "auto" }}
            >
              {catalogoProdutos.length === 0 ? (
                <p className="text-muted">Nenhum treinamento disponível.</p>
              ) : (
                <>
                  <p style={{ marginBottom: 12 }}>
                    <button
                      type="button"
                      className="btn btn-default btn-sm"
                      onClick={selecionarTodasOpcoes}
                    >
                      Selecionar todas
                    </button>
                  </p>
                  <ul className="list-unstyled" style={{ marginBottom: 0 }}>
                    {catalogoProdutos.map((p) => {
                      const pid = idStr(p._id);
                      return (
                        <li key={pid} className="checkbox" style={{ marginTop: 8 }}>
                          <label
                            style={{ fontWeight: "normal", cursor: "pointer" }}
                          >
                            <input
                              type="checkbox"
                              checked={draft.some((x) => idStr(x) === pid)}
                              onChange={() => toggleDraft(p._id)}
                              style={{ marginRight: 8 }}
                            />
                            {p.titulo}
                          </label>
                        </li>
                      );
                    })}
                  </ul>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default pull-left"
                data-dismiss="modal"
              >
                Voltar
              </button>
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-primary"
                onClick={confirmar}
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  })
);
